import {
  UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
  EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
  STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
  BONDS_ACCOUNT_CATEGORY,
} from './productCategory';
import {
  UNIT_TRUST_INVESTMENT_ACCOUNT,
  EQUITY_INVESTMENT_ACCOUNT,
  STRUCTURED_PRODUCTS_ACCOUNT,
  BONDS_ACCOUNT,
  HSBC_CONVENTIONAL_UT_ACCOUNT,
  HSBC_AMANAH_UT_ACCOUNT,
} from './productDescriptionCode';
export const productMap = [
  {
    productType: UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
    productCode: UNIT_TRUST_INVESTMENT_ACCOUNT,
    labelText: `accountLabelUnitTrustAccount`,
    calloutText: 'calloutWarningUnitTrustAccount',
  },
  {
    productType: EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
    productCode: EQUITY_INVESTMENT_ACCOUNT,
    labelText: `accountLabelEquityInvestmentAccount`,
    calloutText: 'calloutWarningEquityInvestmentAccount',
  },
  {
    productType: STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
    productCode: STRUCTURED_PRODUCTS_ACCOUNT,
    labelText: `accountLabelStructuredProductsAccount`,
    calloutText: 'calloutWarningStructuredProductsAccount',
  },
  {
    productType: BONDS_ACCOUNT_CATEGORY,
    productCode: BONDS_ACCOUNT,
    labelText: `accountLabelBondsAccount`,
    calloutText: 'calloutWarningBondsAccount',
  },
  {
    productType: UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
    productCode: HSBC_CONVENTIONAL_UT_ACCOUNT,
    labelText: `myUnitTrustLabelText`,
    calloutText: 'calloutWarningUnitTrustAccount',
  },
  {
    productType: UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
    productCode: HSBC_AMANAH_UT_ACCOUNT,
    labelText: `myUnitTrustLabelText`,
    calloutText: 'calloutWarningUnitTrustAccount',
  },
];
